import { CliBaseCommand } from '../../BaseCommand';

import chalk from 'chalk';

export default class ConfigPrint extends CliBaseCommand {
  static enableJsonFlag = true;

  static description = 'print cli config';

  static alias = ['config get'];

  static flags = {
    ...CliBaseCommand.flags,
  };

  static examples = ['$ sb config:print'];

  async run() {
    this.logger.info(chalk.underline(chalk.blue('## Config'.padEnd(24))));
    this.logger.info(this.ctx.toPrettyString());
  }
}
